import {
  LOG_SYNC_EVENT_CHANNEL,
  type SyncEvent,
} from '../../../../electron/shared/sync-telemetry.types';
import { ElectronAPI } from '../base/ElectronAPI';

export class SyncTelemetryAPI extends ElectronAPI {
  logSyncEvent(event: SyncEvent): void {
    this.invoke<void>(LOG_SYNC_EVENT_CHANNEL, event).catch(() => {});
  }
}
